import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getInvitationEmailTemplates,
  createInvitationEmailTemplate,
  updateInvitationEmailTemplate,
  deleteInvitationEmailTemplate,
  type InvitationEmailTemplate,
} from '../../services';

export const invitationEmailTemplateKeys = {
  all: ['invitationEmailTemplates'] as const,
};

export function useInvitationEmailTemplates() {
  return useQuery({
    queryKey: invitationEmailTemplateKeys.all,
    queryFn: getInvitationEmailTemplates,
  });
}

export function useCreateInvitationEmailTemplate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Parameters<typeof createInvitationEmailTemplate>[0]) =>
      createInvitationEmailTemplate(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: invitationEmailTemplateKeys.all });
    },
  });
}

export function useUpdateInvitationEmailTemplate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      publicId,
      data,
    }: {
      publicId: string;
      data: { body_html: string };
    }) => updateInvitationEmailTemplate(publicId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: invitationEmailTemplateKeys.all });
    },
  });
}

export function useDeleteInvitationEmailTemplate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (publicId: string) => deleteInvitationEmailTemplate(publicId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: invitationEmailTemplateKeys.all });
    },
  });
}
